import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {ShopTapBoxV2} from "../common/ShopTapBoxV2";
import {subNavEvent} from "../../../static/js/service/commonService";
import {openPopup2, selectBtnEvent2} from "utils/CommonUtils";
import ShopInfo5Popup from "components/shopInfo5/ShopInfo5Popup";
import MessagePopup from "components/popup/MessagePopup";
import {useShopAdminDetail2} from "../../../static/js/hock/shopHock";
import {useShopInfo5Hook} from "../../../hooks/ShopHook";
import LoadingPopup from "../../popup/LoadingPopup";

export default function ShopInfo5V2() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState("");
  let [approvalTpcd1, setApprovalTpcd1] = useState();
  const [deliverableAreaList, setDeliverableAreaList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useShopInfo5Hook({setDeliverableAreaList}, shopId);
  useShopAdminDetail2({setApprovalTpcd1}, shopId);

  useEffect(() => {
    subNavEvent("shopNav", "shop1");
    document.addEventListener("click", selectBtnEvent2);
  }, []);

  /* 행정동 그룹화 */
  const groupedAreaList = deliverableAreaList.reduce((acc, fullName) => {
    const splitName = fullName.split(' ');
    const dong = splitName.pop();
    const area = splitName.slice(0, 2).join(' ');

    const existingArea = acc.find((item) => item.area === area);
    if (existingArea) {
      existingArea.dongList.push(dong);
    } else {
      acc.push({ area, dongList: [dong] });
    }

    return acc;
  }, []);

  return (
    <>
      <LoadingPopup />
      <ShopInfo5Popup
        shopId={shopId}
        shopDongList={deliverableAreaList}
        setErrorMessage={setErrorMessage}
      />
      <MessagePopup
        text={errorMessage}
      />
      <main id="ShopInfo5V2" className="mainV2">
        <TopBoxV2 shopList={shopList} />
        <div className="container">
          <section id="shopSec1" className="containerInner">
            <PageNameV2 title1="상점 관리" title2="상점 정보 관리" />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="상점 정보 관리" countText="" count="" unit="" />
            </div>
            <div className="topMenu">
              <div id="shopSelectBox">
                <ShopSelectBoxV2 url="/v2/shopInfo5" setShopId={setShopId} setShopList={setShopList} />
                <ShopTapBoxV2 tap="tap5" shopId={ shopId } />
              </div>
              {approvalTpcd1 === 4 &&
                <button id="shopModiBtn" className="openBtn commonBtn width90 ml-5" onClick={() => openPopup2("shopInfo5Popup")}>
                  수정하기
                </button>
              }
            </div>
            <div className="shopInfoBox">
              <table className="shopInfoTable">
                <thead></thead>
                <tbody>
                <tr>
                  <th>배달권역</th>
                  <td className="inputBox">
                    {groupedAreaList.map((value, index) => {
                      return (
                        <React.Fragment key={index}>
                          <p className="fw-7">{value.area}</p>
                          <p className="mb-5 wb-all">{value.dongList.join(", ")}</p>
                        </React.Fragment>
                      )
                    })}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}